import Vue from 'vue';
export const EventBus = new Vue();

export const REGISTER_EVENTS = Object.freeze({
  // A user edit of a Tag saved successfully. The server synchronises linked Register rows
  // automatically, so an open Register table reloads a row that links the Tag. Payload: `{ tagId }`.
  LINKED_TAG_SAVED: 'register:linked-tag-saved',
});

export const DOCUMENT_EVENTS = Object.freeze({
  // Open the Document Workspace on its Versions tab. Payload: `{ documentId }`.
  OPEN_VERSIONS: 'documents:open-versions',
  // Open the Document Workspace. Payload: `{ documentId, revisionId?, tab? }` (tab: details | versions | history | links).
  OPEN_WORKSPACE: 'documents:open-workspace',
  // A document's current version changed (pin, revert, new version). Payload: the DocumentVM.
  DOCUMENT_CHANGED: 'documents:changed',
  // Ask the user what to do with uploads whose names are taken. Payload:
  // `{ conflicts, drafts, scopeLabel, resolve }`; resolve(choicesByIndex) or resolve(null) to cancel.
  RESOLVE_NAME_CONFLICTS: 'documents:resolve-name-conflicts',
});
